module.exports = __webpack_public_path__ + "static/media/city-elements-facilities-5-svgrepo-com.e6c957b7.svg";